import { QueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry(failureCount, error) {
        // do not retry if the error is a 404
        if (isAxiosError(error)) {
          const statusCode = error?.response?.status;
          return !!statusCode && (statusCode < 400 || statusCode >= 500);
        }

        return failureCount < 3;
      },
    },
  },
});
